export default "__VITE_ASSET__D8Du9grm__"